import { createContext } from 'react';
export const RxContext = createContext({});
